/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('DOMContentLoaded', () => {
  const OriginalClass = customElements.get('header-details-disclosure');
  
  // Patch the prototype methods directly
  const proto = OriginalClass.prototype;
  
  proto.mouseLeaveListener = function() {
    if (!document.body.hasAttribute('header-details-disclosure-edit')) {
      this._closeTimer = setTimeout(() => {
        this.close();
      }, 300);
    }
  };

  proto.mouseEnterListener = function() {
    clearTimeout(this._closeTimer);
    if (!document.body.hasAttribute('header-details-disclosure-edit')) {
      this.open();
    }
  };
});

document.addEventListener('DOMContentLoaded', () => {
  const OriginalClass = customElements.get('header-details-disclosure');
  const proto = OriginalClass.prototype;

  proto.mouseLeaveListener = function(e) {
    if (document.body.hasAttribute('header-details-disclosure-edit')) return;
    
    this._closeTimer = setTimeout(() => {
      // Check if mouse is now over the mega menu panel
      const panel = this.content;
      if (!panel) { this.close(); return; }
      
      const rect = panel.getBoundingClientRect();
      const x = e.clientX;
      const y = e.clientY;
      
      const isOverPanel = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      
      if (!isOverPanel) this.close();
    }, 100);
  };

  proto.mouseEnterListener = function() {
    clearTimeout(this._closeTimer);
    if (!document.body.hasAttribute('header-details-disclosure-edit')) {
      this.open();
    }
  };
});